import * as React from "react"

import { FlowAnswer, FlowLearnMoreData, LearnMoreTileSize } from "types"
import * as styles from "./styles.module.scss"
import LearnMoreItem from "../LearnMoreItem"
import TileBorderMedium from "../../TileBorderMedium"
import TileLarge from "../../TileLarge"

export interface LearnMoreProps {
  learnMoreData: FlowLearnMoreData
  userAnswers: any
}

const LearnMore: React.FC<LearnMoreProps> = ({
  learnMoreData,
  userAnswers,
}) => {
  const createItems = () => {
    const largeItems = []
    const mediumItems = []

    Object.keys(learnMoreData).forEach((dKey) => {
      const d = learnMoreData[dKey]
      const dType = d.type as LearnMoreTileSize

      Object.keys(d.answerSpecificContent).forEach((aKey) => {
        const answerSpecificContent: FlowAnswer = d.answerSpecificContent[aKey]
        const { link, title, description } = answerSpecificContent
        let tile
        let itemsOfCertainSize

        switch (dType) {
          case LearnMoreTileSize.Large:
            tile = (
              <TileLarge
                link={link}
                heading={title}
                subhead={description}
                img={d.img}
              />
            )
            itemsOfCertainSize = largeItems
            break
          default:
          case LearnMoreTileSize.Medium:
            tile = (
              <TileBorderMedium
                link={link}
                heading={title}
                subhead={description}
              />
            )
            itemsOfCertainSize = mediumItems
            break
        }

        itemsOfCertainSize.push(
          <LearnMoreItem
            itemKey={aKey}
            size={d.type}
            trigger={d.trigger}
            tile={tile}
            userAnswers={userAnswers}
            key={`learn-more-item-${d.trigger}-${aKey}`}
          />
        )
      })
    })

    return { largeItems, mediumItems }
  }

  const items = createItems()

  return (
    <section className={styles.learnMore}>
      <div className={styles.pagePadding}>
        <div className={styles.header}>
          <h3 className={styles.heading}>More to explore</h3>
        </div>
        <div className={styles.feed}>
          <ul className={styles.grid}>
            {items.largeItems}
            <div className={styles.bundle}>{items.mediumItems}</div>
          </ul>
        </div>
      </div>
    </section>
  )
}

export default LearnMore
